import styled from 'styled-components';

import { noSelect } from 'styles/mixins';
import { COLORS } from 'styles/style-constants';

export const Container = styled.div<{ $disabled?: boolean }>`
    display: flex;
    width: fit-content;
    max-width: 15rem;
    height: 4.8rem;
    border-radius: 3.8rem;
    border: 0.1rem solid ${COLORS.tokenChipBorder};
    padding: 0.8rem;
    background-color: ${COLORS.tokenChipBackground};
    align-items: center;
    gap: 0.8rem;
    cursor: pointer;
    margin: 0.9rem 0;
    position: relative;
    pointer-events: ${props => (props.$disabled ? 'none' : 'unset')};
    ${noSelect};

    &:hover {
        border-color: ${COLORS.inputActiveBorder};
    }
`;
